var Config = {
    LIMIT: "10",
    PERSIST_SECRET_KEY: "abcdefgh12345",
    ENVIRONMENT: "DEVELOPMENT",
    ENVIRONMENTS: {
        LOCAL: {
            API_URL: "https://dev-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://dev-app.casita.kodefuse.com",
        },
        DEVELOPMENT: {
            API_URL: "https://dev-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://dev-app.casita.kodefuse.com",
        },
        STAGING: {
            API_URL: "https://dev-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://dev-app.casita.kodefuse.com",
        },
        PRODUCTION: {
            API_URL: "https://dev-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://dev-app.casita.kodefuse.com",
        },
    },
}

Config.env = () => {
    return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config